import React from 'react';
import tsDate from '@techsee/techsee-date';
import InteractionSummaryEventService from '@techsee/techsee-ui-components/lib/interaction-summary/eventService';
import unionIcon from '../../../../../../../../img/icon-union.png';
import {ITranslate} from '../../../../../../services/LocalizationService';

type InteractionSummaryPreview = {
    sessionId?: string;
    flowName?: string;
    creationTimestamp: string;
};

type InteractionSummaryPreviewCardProps = {
    preview: InteractionSummaryPreview;
    translate: ITranslate;
    dateFormat?: string;
};

export const InteractionSummaryPreviewCard: React.FC<InteractionSummaryPreviewCardProps> = ({
    preview,
    translate,
    dateFormat = 'MMMM D, YYYY h:mm A'
}) => {
    const openPopup = () =>
        (InteractionSummaryEventService as any).toggleWidget({
            sessionId: preview.sessionId || '',
            flowName: preview.flowName || '',
            creationTimestamp: preview.creationTimestamp
        });

    return (
        <div>
            <h6 className='isc-date isc-date--center'>
                {tsDate(new Date(preview.creationTimestamp)).format(dateFormat)}
            </h6>
            <div className='isc-preview-card'>
                <img src={unionIcon} className='isc-preview-icon' alt='' />
                <div className='isc-preview-title'>{preview.flowName || ''}</div>
                <button className='isc-link' onClick={openPopup}>
                    {translate('REACT.INTERACTION.SUMMARY.INTERACTION.SUMMARY')}
                </button>
            </div>
        </div>
    );
};
